"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get CompensationDecisionWidgetRow () {
        return CompensationDecisionWidgetRow;
    },
    get CompensationDecisionsWidgetResponse () {
        return CompensationDecisionsWidgetResponse;
    },
    get MyDecisionParams () {
        return MyDecisionParams;
    },
    get MyDecisionsDirectReportResult () {
        return MyDecisionsDirectReportResult;
    },
    get MyDecisionsResponse () {
        return MyDecisionsResponse;
    },
    get SubmitDecisionsRequest () {
        return SubmitDecisionsRequest;
    },
    get SubmitDecisionsResponse () {
        return SubmitDecisionsResponse;
    },
    get UpdateMyDecisionsNotesRequest () {
        return UpdateMyDecisionsNotesRequest;
    },
    get UpdateMyDecisionsNotesResponse () {
        return UpdateMyDecisionsNotesResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _money = require("@performyard/money");
const _utilsisomorphic = require("@performyard/utils-isomorphic");
const _response = require("../response");
const _response1 = require("./response");
const MyDecisionParams = _zod.z.object({
    cycleId: _utilsisomorphic.transformObjectId
});
const MyDecisionsDirectReportResult = _zod.z.object({
    id: _utilsisomorphic.transformObjectId,
    companyId: _utilsisomorphic.transformObjectId,
    compensationCycle: _utilsisomorphic.transformObjectId,
    employeeId: _utilsisomorphic.transformObjectId,
    createdAt: _zod.z.coerce.date(),
    managerId: _utilsisomorphic.transformObjectId,
    overrideManagerId: _utilsisomorphic.transformObjectId.nullable(),
    currentSalary: _money.transformWireMoney,
    currentSalaryCurrency: _zod.z.string(),
    // The manager group's allocated share of the cycle budget, repeated on every
    // row of the group. Null on cycles created before group budgets were
    // allocated; consumers fall back to deriving from the cycle percent.
    groupIncreaseBudget: _money.transformWireMoneyNullable,
    proposedIncreaseAmount: _money.transformWireMoneyNullable,
    proposedIncreasePercent: _zod.z.number().min(0).nullable(),
    proposedSalary: _money.transformWireMoneyNullable,
    status: _models.EmployeeCompensationModel.shape.status,
    currentApproverId: _utilsisomorphic.transformObjectId.nullable(),
    approvals: _zod.z.array(_response.BudgetReviewApprovalEntry),
    name: _zod.z.string(),
    jobTitle: _zod.z.string(),
    role: _zod.z.object({
        id: _utilsisomorphic.transformObjectId,
        name: _zod.z.string()
    }).nullable(),
    managerName: _zod.z.string(),
    currentManagerViewing: _zod.z.string(),
    updatedAt: _zod.z.coerce.date().optional(),
    myDecisionNotes: _zod.z.string().nullable().optional()
});
const MyDecisionsResponse = _zod.z.object({
    compensationCycleDetails: _response1.CompensationCycleResponse.nullable(),
    directReportsToMakeDecisionsFor: _zod.z.object({
        results: _zod.z.array(MyDecisionsDirectReportResult),
        total: _zod.z.number()
    })
});
const CompensationDecisionWidgetRow = _zod.z.object({
    cycleId: _utilsisomorphic.transformObjectId,
    name: _zod.z.string(),
    dueDate: _zod.z.coerce.date(),
    status: _zod.z.enum([
        "active",
        "overdue"
    ])
});
const CompensationDecisionsWidgetResponse = _zod.z.object({
    results: _zod.z.array(CompensationDecisionWidgetRow)
});
const UpdateMyDecisionsNotesRequest = _zod.z.object({
    cycleId: _zod.z.string(),
    managerId: _zod.z.string(),
    notesByDecisionRowId: _zod.z.record(_zod.z.string(), _zod.z.string())
});
const UpdateMyDecisionsNotesResponse = _zod.z.object({
    success: _zod.z.boolean()
});
const SubmitDecisionsRequest = _zod.z.array(_zod.z.object({
    _id: _zod.z.string(),
    current_salary: _money.transformWireMoney,
    employee_id: _zod.z.string(),
    notes: _zod.z.string(),
    proposed_increase_amount: _money.transformWireMoneyNonNegative,
    // A percent is a ratio, not money; it stays a plain number.
    proposed_increase_percent: _zod.z.number().nonnegative(),
    proposed_salary: _money.transformWireMoneyNonNegative,
    compensation_cycle_id: _zod.z.string()
}));
const SubmitDecisionsResponse = _zod.z.object({
    success: _zod.z.boolean()
});
